const prodKey = '6LdhGfspAAAAALo4_g5XoaAlwHAmekewAb_ijjXo';
const devKey = "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";
let recaptchaSiteKey = prodKey;

if (process['env.NODE_ENV'] === 'development') {
  recaptchaSiteKey = devKey;
}

// GOOGLE_RECAPTCHA_PUBLIC_KEY
export default recaptchaSiteKey;